import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, User as UserIcon } from "lucide-react";
import PlanCards from "@/components/PlanCards";
import { useAuth } from "@/lib/auth";
import { usePaywall } from "@/lib/access";

const btn = "whitespace-nowrap inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.25em] uppercase font-bold border-2 border-[#111] px-3 py-1.5 hover:bg-[#111] hover:text-[#F4F3EC] transition-colors focus-ring active:translate-y-px";

export default function LockoutScreen() {
  const { user, logout } = useAuth();
  const { openSignIn } = usePaywall();
  const navigate = useNavigate();

  async function handleSignIn() {
    navigate("/tracker", { replace: true });
    await logout();
    openSignIn("signin");
  }
  async function handleSignOut() {
    await logout();
    window.location.assign("/");
  }

  return (
    <main className="fixed inset-0 z-[70] overflow-y-auto bg-[#F4F3EC] text-[#111]" data-testid="lockout-screen">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10">
        <div className="flex items-center justify-between gap-4 border-b-2 border-[#111] pb-4">
          <span className="font-display text-2xl font-extrabold tracking-tight">guidedsport<span className="opacity-60">.</span></span>
          <div className="flex items-center gap-2">
            <button type="button" onClick={handleSignIn} className={btn} data-testid="lockout-signin-btn">
              <UserIcon size={11} strokeWidth={2.6} /> Sign in
            </button>
            <button type="button" onClick={handleSignOut} className={btn} data-testid="lockout-signout-btn">
              <LogOut size={11} strokeWidth={2.6} /> Sign out
            </button>
          </div>
        </div>
        <div className="mt-10 mb-10 max-w-3xl">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#555] font-bold">{user?.email}</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[0.95]" data-testid="lockout-title">
            Your 3-day free trial has ended – choose a plan
          </h1>
          <p className="mt-4 text-[#555] text-base">Subscribe to get your schedule back. Already paying on another account? Sign in with it.</p>
        </div>
        <PlanCards prefix="lockout" />
      </div>
    </main>
  );
}
